import React, { useMemo } from 'react';

import { useTheme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import { OPPORTUNITY_COCKPIT_MEDIA } from '../../utils';
import {
    decorImage,
    leadIcon,
    root,
    rootBelowLg,
    subtitleStyle,
    textColumn,
    titleStyle,
} from './OpportunityOverviewBanner.style';

const OpportunityOverviewBanner = ({
    userName = 'Jamie Grey',
    subtitle = 'A unified command center for opportunities—combining spend insights, contract intelligence, and workflow actions in real time.',
}) => {
    const theme = useTheme();
    const belowLg = useMediaQuery(theme.breakpoints.down('lg'));
    const rootStyle = useMemo(
        () => (belowLg ? { ...root, ...rootBelowLg } : root),
        [belowLg]
    );

    return (
        <div style={rootStyle}>
            <img src={OPPORTUNITY_COCKPIT_MEDIA.topCardDecor} alt="" style={decorImage} />
            <img src={OPPORTUNITY_COCKPIT_MEDIA.overviewLeadIcon} alt="" style={leadIcon} />
            <div style={textColumn}>
                <Typography style={titleStyle}>{`Welcome! ${userName}`}</Typography>
                <Typography style={subtitleStyle}>{subtitle}</Typography>
            </div>
        </div>
    );
};

export default OpportunityOverviewBanner;
